
export enum ModuleView {
    Table = "table",
    Chart = "chart",
    Dual = "dual",
}

export enum ChartView {
    Legend = "legend",
    DataLabels = "dataLabels"
}

export enum SpecialGroupName {
    Other = "Other"
}

export type DisplayCheckItem = {
    displayName: string;
    checked: boolean;
}

export type MenuItem = {
    name?: string;
    icon?: string;
    type?: string;
    click?: () => void;
}[]